// Module
var code = "<div class=\"fadeindowm-container animate__animated\" ng-class=\"{'animate__fadeInDown':fadeInDown_isOpen}\"> <span class=\"fadeindowm-size\" ng-bind=\"fadeInDown_message\"></span> </div>";
// Exports
export default code;